import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OriginFilterComponent, OriginListComponent } from './origin-filter/origin-filter.component';
import { TooltipModule } from '@shopping-angular-components/tooltip';


@NgModule({
  declarations: [
    OriginFilterComponent, 
    OriginListComponent
  ],
  exports: [
    OriginFilterComponent
  ],
  imports: [
    CommonModule,
    TooltipModule
  ]
})
export class FilterModule { }
